import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Translate, Localize } from 'react-redux-i18n';
import Dropzone from 'react-dropzone';
import { Link } from 'react-router';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';

import { UI_HEIGHT } from '../Common/constants';
import checkPermission from '../Common/permissions';
import FilterToolbar from "../Common/FilterToolbar.jsx";
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { ROOT_URL, companyCodeTitle } from '../../actions/root_url';

class Vendors extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.customersPage,

      rows: [],
      selectedRows: null,
      filters: {},
      sortColumn: null,
      sortDirection: null,
      files: null,
    };

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.fetchVendors();
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // Once vendors ready, reset state.

  componentWillReceiveProps(nextProps) {
    if (nextProps.vendors && nextProps.vendors != this.props.vendors) {
      this.setState({ rows: nextProps.vendors });
    }
  }

  handleResize(e) {
    this.setState({tableHeight: window.innerHeight - UI_HEIGHT.customersPage});
  }

  // Set vendor being selected to be currentVendor and navigate user to the edit page
  onDrop(files) {
    if (files) {
      alert('Upload takes time, please stay on the current page');
    }
    this.props.attachDocument(files);
    this.setState({ files });
  }

  setCurrentVendor(e) {
    e.preventDefault();
    const currentVendor = this.state.selectedRows[0];
    this.props.resetCurrentVendor();
    this.props.selectVendor(currentVendor);
    this.context.router.push('/vendors/'+currentVendor.Vendor_id);
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentVendor();
    this.context.router.push('/vendors/new');
  }

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

  renderTable() {
    if (this.props.isLoading && !this.props.error) {
      return (
        <Spinner/>
      );
    } else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.error)}
          </div>
        </ContentWrapper>
      );
    } else {
      // Parameters of the react-data-grid

      const getRows = () => {
        return Data.Selectors.getRows(this.state);
      }

      const getSize = () => {
        return getRows().length;
      }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

          // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
        this.setState(state);
      }

      const handleFilterChange = filter => {
        let newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
            newFilters[filter.column.key] = filter;
        } else {
            delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      }

      //Custom Formatter component
      const IsActiveFormatter = React.createClass({
        render() {
          if (this.props.value) return <span className="label label-success"><Translate value="active" /></span>;
          else return <span className="label label-danger"><Translate value="inactive" /></span>;
        }
      });

      // Handle the row select function

      const onRowSelect = rows => {
        this.setState({ selectedRows: rows });
      }

      // Column difinition

      const columns = [
        {
          key: 'VendorNum',
          name: <Translate value="vendor_no" />,
          width: 125,
          resizable: true,
          sortable: true,
          filterable: true
        },
        {
          key: 'Name',
          name: <Translate value="name" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 250,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          width: 200,
          resizable: true,
          sortable: true,
          filterable: true
        },
        {
          key: 'PaymentTerm_id__Name',
          name: <Translate value="payment_term" />,
          width: 120,
          resizable: true,
          sortable: true,
          filterable: true
        },
        {
          key: 'CreditStatus',
          name: <Translate value="credit_status" />,
          width: 120,
          resizable: true,
          sortable: true,
          filterable: true
        },
        {
          key: 'IsActive',
          name: <Translate value="active" />,
          width: 65,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: IsActiveFormatter
        }
      ]

      return (
        //React Table Vendors List
        <Row>
          <Col sm={ 12 }>
            <div id="Vendors-dataGrid1">
              <ReactDataGrid
                rowKey='Vendor_id'
                enableCellSelect={true}
                onGridSort={handleGridSort}
                toolbar={<FilterToolbar enableFilter/>}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize() }
                minHeight={this.state.tableHeight}
                enableRowSelect='single'
                onRowUpdated={this.handleRowUpdated}
                onRowSelect={onRowSelect}
              />
            </div>
          </Col>
        </Row>
      )
    }
  }

  render() {
    let height = (this.state.tableHeight + 70).toString();
    let tableCollapseFix = {height: height}
    const excelUrl = `${ROOT_URL}v1/vendor/export/?Bearer=${localStorage.getItem('token')}`;
    const excelUrlBarcode = `${ROOT_URL}v1/vendor/export-product-barcode/${this.state.selectedRows && this.state.selectedRows[0].Vendor_id}/?Bearer=${localStorage.getItem('token')}`;
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management"  />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="vendor" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <Grid fluid="true" id="vendors-page">
          <h1><Translate value="manage_vendors" /></h1>
          <Row>
            <Col md={ 12 }>
              <Panel className="position-relative" style={tableCollapseFix}>
                <ButtonToolbar className="table-buttons" style={{ display: 'flex' }}>
                  <Button
                    bsStyle="success"
                    type="submit"
                    onClick={(event) => { this.clickNew(event) } }
                    disabled={!checkPermission("add_vendor")}
                  >
                    <em className="fa fa-plus" /><Translate value="create" />
                  </Button>
                  <Button
                    bsStyle="warning"
                    onClick={(event) => { this.setCurrentVendor(event) } }
                    disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !checkPermission("change_vendor")}
                  >
                    <em className="fa fa-pencil"/><Translate value="edit" />
                  </Button>
                  <Button
                    bsStyle="success"
                    type="button"
                    href={excelUrl}
                  >
                    <em className="fa fa-download"/><Translate value="excel" />
                  </Button>
                  <Button
                    bsStyle="success"
                    type="button"
                  //   onClick={(event) => { console.log('this.state', this.state) } }
                    disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    href={excelUrlBarcode}
                  >
                    <em className="fa fa-download"/><Translate value="barcode_export" />
                  </Button>
                  <Dropzone onDrop={this.onDrop.bind(this)} style={{ 'padding-left': '5px' }} className="upload-button">
                    <Button bsStyle="primary" >
                      <em className="fa fa-file-text" />
                      <Translate value="upload_import" />
                    </Button>
                  </Dropzone>
                </ButtonToolbar>
                {/* Vendor Table */}
                {this.renderTable() }
              </Panel>
            </Col>
          </Row>
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default Vendors;



// WEBPACK FOOTER //
// ./master/jsx/components/Vendors/vendors.jsx